export const LOW_INVENTORY_AMOUNT = 3;
